export default "__VITE_ASSET__CHlNE_kJ__"